<!-- 了解你 -->
<template>
  <div style="height: 100%;">
    <Header></Header>
    <div class="know tc">
      <p class="fb tl f20 pt20 mL20">了解你</p>
      <div class="mb20 mt80 f20">
        <span class="inline-block tl">年龄</span>
        <el-input v-model="age" placeholder="请输入年龄" type="text"></el-input>
      </div>
<!--      <div class="mb20 f20">-->
<!--        <span class="inline-block tl">性别</span>-->
<!--&lt;!&ndash;        <el-input v-model="age" placeholder="请输入性别" type="text"></el-input>&ndash;&gt;-->
<!--        <el-select v-model="gender" placeholder="请输入性别">-->
<!--          <el-option v-for="item in genderOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>-->
<!--        </el-select>-->
<!--      </div>-->
      <div class="mb20 f20">
        <span class="inline-block tl">性别</span>
        <el-radio-group v-model="gender" style='width: 518px; text-align: left'>
          <el-radio v-for="item in genderOptions" :key="item.value" :label="item.value">{{item.label}}</el-radio>
        </el-radio-group>
      </div>
<!--      <div class="mb20 f20">-->
<!--        <span class="inline-block tl">现有资产规模</span>-->
<!--        <el-input v-model="alreadyScaleSaving" placeholder="请输入已有储蓄规模" type="text"></el-input>-->
<!--      </div>-->
<!--      <div class="mb20 taxSpend f20">-->
<!--        <span class="inline-block tl">税前工资收入</span>-->
<!--        <el-select v-model="beforeTax" placeholder="月度">-->
<!--          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>-->
<!--        </el-select>-->
<!--        <el-input v-model="preTaxIncome" placeholder="请输入税前收入" type="text"></el-input>-->
<!--      </div>-->
<!--      <div class="mb20 taxSpend f20">-->
<!--        <span class="inline-block tl">其他收入</span>-->
<!--        <el-select v-model="other" placeholder="月度">-->
<!--          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>-->
<!--        </el-select>-->
<!--        <el-input v-model="otherIncome" placeholder="请输入其他收入" type="text"></el-input>-->
<!--      </div>-->
<!--      <div class="mb20 taxSpend f20">-->
<!--        <span class="inline-block tl">预估支出</span>-->
<!--        <el-select v-model="spending" placeholder="月度">-->
<!--          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>-->
<!--        </el-select>-->
<!--        <el-input v-model="estimatedExpenses" placeholder="请输入预估支出" type="text"></el-input>-->
<!--      </div>-->
      <div class="tr" style="width:670px;margin: 100px auto"><el-button class="co-f mt20 base-bg base-border-color" @click="saveBaseInfo">下一步</el-button></div>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue'
export default {
  name: 'Home',
  data () {
    return {
      age: '',
      gender: 'male',
      alreadyScaleSaving: '',
      preTaxIncome: '',
      otherIncome: '',
      estimatedExpenses: '',
      password: '',
      beforeTax: 'm',
      spending: 'm',
      other: 'm',
      genderOptions: [{'value':'male', 'label':'男'}, {'value':'female', 'label': '女'}],
      options: [{'value':'m', 'label':'月度'}, {'value':'y', 'label':'年度'}],
      getToken: ''
    }
  },
  components: { Header },
  computed: {
    token () {
      return this.$store.getters.getToken
    }
  },
  mounted () {
    let routerParam = this.$route.query.param
    if (routerParam) {
      const paramStr = atob(routerParam)
      this.account = paramStr.split(':')[0]
      this.password = atob(paramStr.split(':')[1])

      const url = this.$api.Login
      let data = new FormData()
      data.append('username', this.account)
      data.append('password', this.password)
      this.$http.post(url, data, {}, window._env_.api_url, res => {
        if (res.status >= 200 && res.status < 300) {
          localStorage.setItem('username', this.account)
          localStorage.setItem('token', res.data.access_token)
          this.$store.dispatch('setToken', res.data.access_token)
          this.token = res.data.access_token
          if(!this.token){
            this.$router.push({ name: 'Login' })
          }
        }
      })
    } else {
      this.getToken = this.token === '' ? localStorage.getItem('token') : this.token
      if(!this.token){
        this.$router.push({ name: 'Login' })
      }
    }

   },
  methods: {
    saveBaseInfo () {
      const baseInfo = {
        'age': this.age,
        // 'alreadyScaleSaving': this.alreadyScaleSaving,
        // 'preTaxIncome': this.beforeTax === 'm' ? this.preTaxIncome : this.preTaxIncome / 12,
        // 'otherIncome': this.other === 'm' ? this.otherIncome : this.otherIncome / 12,
        // 'estimatedExpenses': this.spending === 'm' ? this.estimatedExpenses : this.estimatedExpenses / 12,
        'gender': this.gender
      }
      // if (baseInfo.age === "" || baseInfo.alreadyScaleSaving === "" || baseInfo.preTaxIncome === "" ||
      //   baseInfo.otherIncome === "" || baseInfo.estimatedExpenses === "" || baseInfo.gender === "") {
      if (baseInfo.age === "" || baseInfo.gender === "") {
        this.$message({type: 'error', message: '请输入完整信息！'})
      } else {
        this.$router.push({name: 'KnowMore', params:baseInfo})
      }
    }
  }
}
</script>

<style scoped>
.know{
   width: 830px;
   height: 453px;
   border-radius: 20px;
   background: #fff;
   margin: 120px auto;
}
.know >>> .inline-block{
  width: 150px;
}
.el-input{
  width: 518px;
}
.taxSpend .el-select{
  width: 85px;
}
.taxSpend .el-input{
  width: 420px;
  margin-left: 10px;
}
.know .el-button{
  height: 30px;
  line-height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/KnowYou.vue